import { render, staticRenderFns } from "./BarTitleDialog.vue?vue&type=template&id=913f6e7c&scoped=true&"
import script from "./BarTitleDialog.vue?vue&type=script&lang=js&"
export * from "./BarTitleDialog.vue?vue&type=script&lang=js&"
import style0 from "./BarTitleDialog.vue?vue&type=style&index=0&id=913f6e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913f6e7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
